import React from 'react';

import { Item, Label, StyledCartSummary, Value } from './CartSummary.style';

interface CartSummaryItemDescriptor {
    label: string;
    value: string | number;
}

export interface CartSummaryProps {
    items: CartSummaryItemDescriptor[];
}

const FALLBACK_ITEM: CartSummaryItemDescriptor = {
    label: 'Retrieving data…',
    value: 'Pending',
};

export function CartSummary({ items = [] }: CartSummaryProps) {
    const itemRenderer = ({ label, value }: CartSummaryItemDescriptor) => (
        <Item key={`CartSummary-Item-${label}`}>
            <Label>{label}</Label>
            <Value>{value}</Value>
        </Item>
    );

    const itemsMarkup = items.length ? items.map(itemRenderer) : [FALLBACK_ITEM].map(itemRenderer);

    return <StyledCartSummary>{itemsMarkup}</StyledCartSummary>;
}
